"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const three_1 = require("three");
const DRCLoader_1 = __importDefault(require("./DRCLoader"));
// eslint-disable-next-line import/no-cycle
const types_1 = require("../../../store/types");
// eslint-disable-next-line import/no-cycle
const utils_1 = require("../../../utils/utils");
const material_1 = require("../material");
// eslint-disable-next-line import/no-cycle
const models_1 = require("../models");
const decoderURL = 'https://www.gstatic.com/draco/versioned/decoders/1.5.5/';
function instantiateComponent(componentType) {
    let component;
    if (componentType === types_1.COMPONENT_TYPE.FASTENER) {
        component = new models_1.Fastener();
    }
    else {
        component = new models_1.Component();
    }
    return component;
}
function instantiateObject(itemType, componentType, isScalable = false) {
    let object;
    if (itemType === types_1.ITEM_TYPE.EXTRUSION && isScalable) {
        object = new models_1.Extrusion();
    }
    else if (componentType === types_1.COMPONENT_TYPE.PANEL) {
        object = new models_1.Panel();
    }
    else {
        object = instantiateComponent(componentType);
    }
    return object;
}
class DRCLoaderHelper extends DRCLoader_1.default {
    constructor() {
        super();
        this.setDecoderPath(decoderURL);
        this.preload();
    }
    loadFile(item) {
        const path = (0, utils_1.formatAssetsURL)(item.meshFile.url);
        return new Promise((resolve) => {
            this.load(path, (geometry) => {
                var _a, _b;
                const itemType = item.itemType.name;
                const componentType = (_a = item.componentType) === null || _a === void 0 ? void 0 : _a.name;
                const object = instantiateObject(itemType, componentType, item.is_scalable);
                const color = (_b = item.color) === null || _b === void 0 ? void 0 : _b.rgb_value;
                const material = color ? (0, material_1.DarkMetalBaseMaterial)(color) : (0, material_1.MetalBaseMaterial)();
                const mesh = new three_1.Mesh(geometry, material);
                object.baseColor = material.color.clone();
                object.add(mesh);
                object.mesh = mesh;
                object.partMetadata.copy(geometry.userData);
                object.setCatalogProps(item);
                object.computeInitialSnappingMetadata();
                resolve(object);
            }, null, () => {
                resolve(null);
            });
        });
    }
}
exports.default = DRCLoaderHelper;
